import React from 'react'
import ResourcesProvider, { useResources } from './ResourcesProvider'
import { useLocation, BrowserRouter } from 'react-router'

import useTranslation, {
  TranslationProvider,
} from '~/components/shared/TranslationProvider'
import translations from './locales.json'

import { TabNav } from '~/components/shared/TabNav'
import TabNavButtons from './TabNavButtons'
import TabNavPanelContainer from './TabNavPanelContainer'

const ResourcesInner = () => {
  const { moduleName } = useResources()
  const { t } = useTranslation('index')
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const id = params.get('id')
  const defaultTab = id ? id : 'articles'

  return (
    // CTS-9269 — Plan 06 visual baseline: resource-center-index capture root
    <div
      className="tw-enable min-h-[70vh] font-[Roboto] lg:flex lg:flex-row"
      data-testid="resource-center-index"
    >
      <div className="lg:max-w/full mx-2 flex-grow sm:mx-8">
        <h1 className="mb-4 mt-10 font-roboto-slab text-2xl text-3.5xl font-medium leading-normal text-primary">
          {t('resources_title')}
        </h1>
        <div className="mb-6 text-lg leading-7 text-[#4a5463] lg:max-w-[75%]">
          {t(`${moduleName}_intro`)}
        </div>
        <TabNav defaultActiveTab={defaultTab} mobileMode="dropdown">
          <TabNavButtons />
          <TabNavPanelContainer />
        </TabNav>
      </div>
    </div>
  )
}

const Resources = ({ locale, ...props }) => {
  return (
    <BrowserRouter>
      <TranslationProvider
        locale={locale}
        translations={translations}
        scope="javascript.components.Resources"
      >
        <ResourcesProvider {...props}>
          <ResourcesInner />
        </ResourcesProvider>
      </TranslationProvider>
    </BrowserRouter>
  )
}

export default Resources
